/*global window*/

/**
 * if adobeDTM will get blocked will have a stub that will prevent exceptions
 */
(function (MOVE) {
    "use strict";

    var init = function () {
        if (!window._satellite) {
            window._satellite = {
                track: function () {

                }
            };
        }
    };

    MOVE.addWorkaround({
        init: init
    });

}(MOVE || {}));



// WEBPACK FOOTER //
// ./_workarounds/workaround_ad_blockers.js